import { ACTIONS_TYPES } from "../utils/constants";

export const initialState = {
  jobCards: null,

  createdJob: null,
  createErrors: null,
  createLoader: false,
  createSuccess: false,

  fetchError: null,
  fetchLoader: null,
  fetchSuccess: false,

  workspaceJobCards: [],
  workspaceError: null,
  workspaceLoader: false,
  workspaceSuccess: false,

  viewJobDetails: null,
  viewJobErrors: null,
  viewJobSuccess: false,
  viewJobLoader: false,

};

export default function jobCardReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS_TYPES.CREATE_JOB_CARD_REQUEST:
      return { ...state, createLoader: true, createErrors: null, createSuccess: false };

    case ACTIONS_TYPES.CREATE_JOB_CARD_SUCCESS:
      return { ...state, createdJob: action.payload, createLoader: false, createSuccess: true };

    case ACTIONS_TYPES.CREATE_JOB_CARD_FAILED:
      return { ...state, createLoader: false, createErrors: action.payload };

    case ACTIONS_TYPES.FETCH_JOBCARDS_REQUEST:
      return { ...state, fetchLoader: true, fetchError: null, fetchSuccess: false };

    case ACTIONS_TYPES.FETCH_JOBCARDS_SUCCESS:
      return { ...state, jobCards: action.payload, fetchLoader: false, fetchSuccess: true };

    case ACTIONS_TYPES.FETCH_JOBCARDS_FAILED:
      return { ...state, fetchLoader: false, fetchError: action.payload };

    case ACTIONS_TYPES.FETCH_MY_WORKSPACE_JOBCARDS_REQUEST: 
      return { ...state, workspaceLoader: true };

    case ACTIONS_TYPES.FETCH_MY_WORKSPACE_JOBCARDS_SUCCESS: 
      return { ...state, workspaceLoader: false, workspaceJobCards: action.payload };

    case ACTIONS_TYPES.FETCH_MY_WORKSPACE_JOBCARDS_FAILED:
      return { ...state, workspaceLoader: false, workspaceError: action.payload };

    case ACTIONS_TYPES.VIEW_JOB_REQUEST:
      return { ...state, viewJobLoader: true, viewJobErrors: null, viewJobSuccess: false };

    case ACTIONS_TYPES.VIEW_JOB_SUCCESS:
      return { ...state, viewJobDetails: action.payload, viewJobLoader: false, viewJobSuccess: true };

    case ACTIONS_TYPES.VIEW_JOB_FAILED:
      return { ...state, viewJobLoader: false, viewJobErrors: action.payload };
  

    case ACTIONS_TYPES.FETCH_JOBCARDS_RESET:
    case ACTIONS_TYPES.CREATE_JOB_CARD_RESET:
    case ACTIONS_TYPES.LOGOUT_REQUEST:
      return { ...initialState  };

    default:
      return state;
  }
}